import React, { useRef, useEffect, useState } from 'react'
import { useNavState } from 'assets/useNavState'
import ky from 'ky'
import { captureException } from '@sentry/browser'

const config = {
  appname: 'Home',
  color: '#E25252',
  links: [
    // {name: 'Home', href: '#/'},
  ],
  dropdownLinks: [{ name: 'User Settings', href: '#/settings' }],
}

function Nav() {
  const ref = useRef()
  const [isOpen, setOpen] = useNavState()
  const { ArcNav } = window as any

  useEffect(() => {
    const config = {
      attributes: true,
    }
    const observer = new MutationObserver((list, observer) => {
      /**
       * Since we are observing only the attributes on the subnav div
       * there should only be one mutation at a time
       */
      if (list.length > 1 || list[0].type !== 'attributes') return

      /** Arcnav adds a class when nav is open (2), removes class when closed (1) */
      // @ts-ignore
      setOpen(list[0].target.classList.length === 2)
    })

    /**
     * ArcNav adds random generated classnames, so we can't base finding the node on that but
     * the subnav is always the first child in the nav
     *
     * Need better solution in long term
     */
    // @ts-ignore
    const subNavTree = ref.current.children[0].children[0].children[0]
    observer.observe(subNavTree, config)
    return () => observer.disconnect()
  }, [setOpen])

  return (
    <div ref={ref}>
      <ArcNav
        appname={config.appname}
        color={config.color}
        links={config.links}
        dropdownLinks={config.dropdownLinks}
        isQuickNavOpen={isOpen}
        enablePendo={true}
      />
    </div>
  )
}

export default Nav
